// for add employee state
export const ADD_EMPLOYEE_DATA = "add_employee_data";
